import { randomUUID } from '@exodus/crypto/randomUUID';
import { createAtomObserver } from '@exodus/atoms';
const createAnalyticsLifecyclePlugin = ({ analytics, shareActivityAtom, analyticsUserIdAtom, analyticsAnonymousIdAtom, port, }) => {
    const shareActivityAtomObserver = createAtomObserver({
        port,
        atom: shareActivityAtom,
        event: 'shareActivity',
    });
    const setPermanentUserId = async () => {
        const [userId, anonymousId] = await Promise.all([
            analyticsUserIdAtom.get(),
            analyticsAnonymousIdAtom.get(),
        ]);
        if (anonymousId === undefined)
            return;
        await analytics.linkUserIds({ userId, anonymousId });
    };
    const onStart = async () => {
        let anonymousId = await analyticsAnonymousIdAtom.get();
        if (!anonymousId) {
            anonymousId = randomUUID();
            await analyticsAnonymousIdAtom.set(anonymousId);
        }
        analytics.setAnonymousId(anonymousId);
    };
    const onLoad = ({ isLocked }) => {
        if (isLocked)
            return;
        shareActivityAtomObserver.start();
    };
    const onCreate = () => {
        void setPermanentUserId();
    };
    const onImport = () => {
        void setPermanentUserId();
    };
    const onUnlock = () => {
        shareActivityAtomObserver.start();
        void analyticsUserIdAtom.get().then(async (userId) => {
            analytics.setUserId(userId);
        });
    };
    const onStop = () => {
        shareActivityAtomObserver.unregister();
    };
    const onClear = async () => {
        await Promise.all([analyticsUserIdAtom.reset(), analyticsAnonymousIdAtom.reset()]);
    };
    return { onStart, onLoad, onCreate, onImport, onUnlock, onStop, onClear };
};
export default createAnalyticsLifecyclePlugin;
